import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { prometheanFont } from '../font/font';
import { PROMETHEAN_TEXT } from '../colors/colors';

/** Headers */
export var PROMETHEAN_TYPOGRAPHY_H1 = {
  fontSize: 72,
  lineHeight: '88px',
  fontWeight: 300,
  letterSpacing: 'normal',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_H2 = {
  fontSize: 48,
  lineHeight: '56px',
  fontWeight: 300,
  letterSpacing: 'normal',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_H3 = {
  fontSize: 32,
  lineHeight: '40px',
  fontWeight: 400,
  letterSpacing: 'normal',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_H4 = {
  fontSize: 24,
  lineHeight: '32px',
  fontWeight: 400,
  letterSpacing: 'normal',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_H5 = {
  fontSize: 20,
  lineHeight: '24px',
  fontWeight: 400,
  letterSpacing: '0.02em',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};

/** Subtitles */
export var PROMETHEAN_TYPOGRAPHY_SUBTITLE_01 = {
  fontSize: 18,
  lineHeight: '24px',
  fontWeight: 400,
  letterSpacing: '0.02em',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_SUBTITLE_02 = {
  fontSize: 16,
  lineHeight: '24px',
  fontWeight: 400,
  letterSpacing: '0.02em',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_SUBTITLE_03 = {
  fontSize: 14,
  lineHeight: '24px',
  fontWeight: 600,
  letterSpacing: '0.01em',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_SUBTITLE_04 = {
  fontSize: 14,
  lineHeight: '24px',
  fontWeight: 400,
  letterSpacing: '0.01em',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};

/** Body */
export var PROMETHEAN_TYPOGRAPHY_BODY = {
  fontSize: 14,
  lineHeight: '24px',
  fontWeight: 400,
  letterSpacing: 'normal',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_BODY_LINK = _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
  textDecoration: 'underline',
  cursor: 'pointer'
});

/** Button */
export var PROMETHEAN_TYPOGRAPHY_BUTTON = {
  fontSize: 14,
  lineHeight: '19px',
  fontWeight: 600,
  letterSpacing: '0.02em',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_BUTTON_UPPERCASE = _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BUTTON), {}, {
  textTransform: 'uppercase'
});
export var PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL = {
  fontSize: 12,
  lineHeight: '16px',
  fontWeight: 600,
  letterSpacing: 'normal',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL_UPPERCASE = _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL), {}, {
  textTransform: 'uppercase'
});

/** Small Text */
export var PROMETHEAN_TYPOGRAPHY_SMALL_TEXT = {
  fontSize: 12,
  lineHeight: '20px',
  fontWeight: 400,
  letterSpacing: 'normal',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_LINK = _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
  textDecoration: 'underline',
  cursor: 'pointer'
});
export var PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE = _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
  letterSpacing: '0.02em',
  textTransform: 'uppercase'
});

/** Eyebrow */
export var PROMETHEAN_TYPOGRAPHY_EYEBROW = {
  fontSize: 10,
  fontWeight: 400,
  lineHeight: '16px',
  letterSpacing: 'normal',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT
};
export var PROMETHEAN_TYPOGRAPHY_EYEBROW_UPPERCASE = _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_EYEBROW), {}, {
  letterSpacing: '0.1em',
  textTransform: 'uppercase'
});

/** Text wrap */
export var PROMETHEAN_TEXT_WRAP = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  wordWrap: 'break-word'
};
export var PROMETHEAN_TABLE_SECONDARY = {
  fontSize: 13,
  lineHeight: '18px',
  fontFamily: prometheanFont
};